const o=({className:a="paywall",index:e=3},l)=>l<e&&a,s=a=>typeof a=="object"&&typeof a.paywall=="object";export{o as getPaywallSeoClass,s as isPaywallSeo};
//# sourceMappingURL=paywallSeo.js.map
